export default __webpack_public_path__ + "static/media/logo_red.8fb97d1a.png";